import { errorMessage } from "../api/client";
import { usePropertyHistoryQuery } from "../api/queries";
import { formatCents, formatUtcDateTime } from "../lib/format";

const TYPE_LABELS: Record<string, string> = {
  INITIAL_ACQUISITION: "Acquired",
  TAKEOVER: "Taken over",
  BRANDING_CHANGED: "Branding changed",
  SEEDED_DEMO: "Demo listing seeded",
  // ADR-0037: the owner's account was deleted; the property is for sale again.
  RETURNED_TO_TOWN: "Returned to the town",
};

/** Safe public acquisition history (docs/06 section 3): no private billing, no visitor data. */
export function PropertyHistory({ propertyId, active }: { propertyId: string; active: boolean }) {
  const query = usePropertyHistoryQuery(propertyId, active);
  if (!active) return null;
  if (query.isPending) return <p className="muted small">Loading history…</p>;
  if (query.error) {
    return (
      <p className="small">
        <span className="error-text">History unavailable:</span> {errorMessage(query.error)}
      </p>
    );
  }
  if (query.data.items.length === 0) return <p className="muted small">No ownership events yet.</p>;
  return (
    <ul className="history-list">
      {query.data.items.map((e) => (
        <li key={e.id}>
          <strong>{TYPE_LABELS[e.type] ?? e.type}</strong>
          {e.ownerLabel ? ` · ${e.ownerLabel}` : ""}
          {e.basisCents !== null ? ` · basis ${formatCents(e.basisCents)}` : ""}
          <div className="faint small">{formatUtcDateTime(e.at)}</div>
        </li>
      ))}
    </ul>
  );
}
